<template>
  <div class="address-wrap" :class="{ show: showMore }">
    <div class="title-wrap">
      <h2 class="title">
        <span>确认收货地址：</span>
        <el-button type="text" @click="addAddress">新增收货地址</el-button>
        <span style="flex: 1"></span>
        <div
          class="show-more"
          v-if="list.length > 4"
          @click="showMore = !showMore"
        >
          <span>{{ !showMore ? '展开更多地址' : '收起更多地址' }}</span>
          <i></i>
        </div>
      </h2>
    </div>
    <div class="address-list">
      <div
        v-for="(item, index) in showMore ? list : list.slice(0, 4)"
        :key="index"
        class="address-item"
        :class="{ active: item.id === addressId }"
        @click="selectAddress(item)"
      >
        <div class="area">
          {{ item.province }} {{ item.city }} {{ item.area }}
        </div>
        <div class="address">{{ item.address }}</div>
        <div class="user">
          <span
            >{{ item.receiveGoodsPerson }} {{ item.receiveGoodsPhone }}</span
          >
        </div>
        <div class="btns">
          <span v-if="item.defaultAddress" class="default">默认</span>
          <div class="do-btn">
            <span @click="editAddress(item)" class="edit-btn">编辑</span>
            <span @click="delAddress(item)" class="edit-btn">删除</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="row.id ? '编辑地址' : '新增地址'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <AddAddress v-if="dialogVisible" @success="success" :row="row" />
    </el-dialog>
  </div>
</template>

<script>
import AddAddress from './addAddress.vue'

export default {
  components: {
    AddAddress
  },
  props: {
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: [],
      showMore: false,
      addressId: 0,
      dialogVisible: false,
      row: {}
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.$http
        .get(`/front/oms/plc/address/listAddress?companyId=${this.companyId}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data
            // 获取默认地址 或者第一个
            if (!this.list.length) {
              return
            }
            const bool = this.list.some((v) => {
              if (v.defaultAddress) {
                this.addressId = v.id
              }
              return v.defaultAddress
            })
            if (!bool) {
              this.addressId = this.list[0].id
            }
          }
        })
    },
    addAddress () {
      this.row = {}
      this.dialogVisible = true
    },
    editAddress (v) {
      this.row = v
      this.dialogVisible = true
    },
    delAddress (row) {
      this.$confirm(`确定要删除该地址吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDelAddress(row)
      })
    },
    doDelAddress (row) {
      this.$http.post(`/front/oms/plc/address/deleteAddress?id=${row.id}`).then(({ data: res }) => {
        if (res.code === 0) {
          this.getList()
          this.$message.success('删除成功')
        }
      })
    },
    selectAddress (item) {
      this.addressId = item.id
    },
    success () {
      this.getList()
      this.dialogVisible = false
    },
    getResult () {
      return this.list.find((v) => v.id === this.addressId)
    }
  }
}
</script>

<style lang="scss" scoped>
.address-wrap {
  background: #fff;
  margin-top: 16px;
  padding: 16px 12px;
  border-radius: 12px;
}

.show {
  .show-more i {
    transform: rotate(180deg);
  }
}

.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0;
  color: #000000;
  .el-button {
    font-size: 12px;
    color: #2a54d1;
  }
  .show-more {
    display: flex;
    align-items: center;
    color: #979799;
    font-size: 12px;
    margin-left: 12px;
    font-weight: normal;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('~@/assets/img/plc/down.png') no-repeat;
      background-size: cover;
      transition: all 0.3s ease;
    }
  }
}

.title-wrap {
  padding: 0 0 16px 28px;
}

.address-list {
  display: flex;
  flex-wrap: wrap;
  transition: all 0.3s ease;
  .address-item {
    position: relative;
    width: 285px;
    color: #3d3d3d;
    border-radius: 8px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid rgba(42, 84, 209, 0.2);
    margin: 0 0 12px 12px;
    padding: 12px 12px 12px 63px;
    cursor: pointer;
    &.active {
      border: 1px solid #2a54d1;
    }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    &::before {
      position: absolute;
      left: 15px;
      top: calc(50% - 14px);
      content: '';
      display: block;
      width: 21px;
      height: 28px;
      background: url('~@/assets/img/plc/loc.png') no-repeat center;
      background-size: cover;
    }
  }
  .area {
    font-size: 12px;
    padding-bottom: 4px;
  }
  .address {
    font-size: 16px;
    padding-bottom: 4px;
  }
  .user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  .default {
    display: inline-block;
    width: 32px;
    height: 17px;
    line-height: 17px;
    border-radius: 4px;
    background: #2a54d1;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    cursor: default;
  }
  .do-btn {
    flex: 1;
    text-align: right;
  }
  .edit-btn {
    display: inline-block;
    width: 40px;
    height: 22px;
    line-height: 20px;
    border-radius: 4px;
    border: 1px solid#ECECF3;
    font-size: 12px;
    background: #ECECF3;
    text-align: center;
    color: #3D3D3D;
    margin-left: 8px;
    &:hover {
      border-color: #2a54d1;
      background: #2a54d1;
      color: #ffffff;
    }
  }
}
</style>
